<template>
  <button class="toggleBox" @click.prevent="handleClick">
    {{ flag ? "收起" : "展开" }}<i :class="`${flag ? '' : 'un'}fold`"></i>
  </button>
</template>

<script>
export default {
  props: {
    flag: Boolean
  },
  methods: {
    handleClick() {
      console.log("handleClick");
      this.$emit("handleClick");
    }
  }
};
</script>

<style scoped lang="scss">
.toggleBox {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #3a61b1;
  line-height: 30px;
  margin-left: 28px;
  // position: absolute;
  // right: 0;
  cursor: pointer;
  border: 0;
  background: none;
  width: 56px;
  .fold {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_left.png") no-repeat;
    background-size: contain;
    width: 7px;
    height: 12px;
    display: inline-block;
    transform: rotate(90deg);
    margin-left: 10px;
  }
  .unfold {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_left.png") no-repeat;
    background-size: contain;
    width: 7px;
    height: 12px;
    display: inline-block;
    transform: rotate(270deg);
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Toggle.vue